// Gets config from index.html making it possible to release different environments with a single build
// remember to also add inside index.html
const releaseConfig = {
  ...globalThis.MyConfig,
  uploadTemplatesUrl: globalThis.MyConfig.uploadTemplatesUrl.startsWith('#{')
    ? 'https://npstodaydevelopment.blob.core.windows.net/upload-templates'
    : globalThis.MyConfig.uploadTemplatesUrl
};

export default releaseConfig;
